export { ThermalResistanceCalculator } from './ThermalResistanceCalculator';
